<template>
    <div class="harf-block"> 
      <div class="big-block" >
        <div class="title-block">
          <span class="text">价格/库存</span>
        </div>
        <div class="form-content">
          <div class="row">
            <div class="tip">ERP编码</div>
            <div class="value input">
              <el-input
                size="small"
                placeholder="请输入"
                v-model="formIn.medicineCode"
                maxlength="20"
                :disabled="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="tip"><span class="weight">*</span> 总库存</div>
            <div class="value input">
              <el-input
                size="small"
                placeholder="请输入"
                v-model="formIn.goodsSkuInventory"
                :disabled="true"
                maxlength="8"
                v-positive-integer
              />
            </div>
            <div class="value fill">
              <el-checkbox
                v-model="formIn.beSynStock"
                ref="checkboxSynStock"
                :disabled="true"
                >自动同步库存</el-checkbox
              >
            </div>
          </div> 
  
          <div class="row">
            <div class="tip"><span class="weight">*</span>单位</div>
            <div class="value input">
              <el-select
                v-model="formIn.goodsSkuUnit"
                placeholder="请选择"
                size="small"
                :disabled="true"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
  
          <div class="row">
            <div class="tip"><span class="weight">*</span>起批量</div>
  
            <div class="value input">
              <el-input
                size="small"
                placeholder="请输入"
                v-model="formIn.startWholesale"
                maxlength="4"
                v-positive-integer
                :disabled="true"
              />
            </div>
  
            <div class="value fill">
              <el-checkbox v-model="formIn.useTimes" :disabled="true">倍数购买</el-checkbox>
            </div>
          </div>
  
          <div class="row">
            <div class="tip"><span class="weight">*</span>有效期至</div>
            <div class="value input">
              <el-date-picker
                v-model="formIn.expireTime"
                type="date"
                placeholder="请选择"
                size="small"
                :editable="false"
                value-format="yyyy-MM-dd"
                :disabled="true"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="row">
            <div class="tip"><span class="weight">*</span>生产日期</div>
            <div class="value input">
              <el-date-picker
                v-model="formIn.producedTime"
                type="date"
                placeholder="请选择"
                size="small"
                :editable="false"
                value-format="yyyy-MM-dd"
                :disabled="true"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
  
      <div class="big-block">
        <div class="title-block">
          <span class="text">图片/其他</span>
        </div>
        <div class="form-content">
          <div class="row">
            <div class="tip"><span class="weight">*</span>商品标题</div>
            <div class="value input goods-title">
              {{ formIn.goodsSkuTitle }}
            </div>
          </div>
          
          <div class="row">
            <div class="tip">产品批号</div>
            <div class="value input">
              <el-input
                size="small"
                placeholder="请输入"
                v-model="formIn.batchNumber"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </template>
  <script>
  import _ from "lodash";
  export default {
    components: {  },
    props: {
      formIn: {
        type: Object,
        default: () => {
          return {
            goodsSkuUnit: "", 
            goodsSkuTitle: "", //商品标题 
            batchNumber: "",
            shopLabelId: "", 
            useTimes:false,
            beSynStock:false,
          };
        },
      },
      selectType: {
        type: Object,
        default: () => {
          return {};
        },
      },
      fileList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      unitList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      imageUrlList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      shopLabelList: {
        type: Array,
        default: () => {
          return [];
        },
      },
  
      isDisabled: {
        type: Boolean,
        default: () => {
          return false;
        },
      },
      name: {
        type: String,
        default: () => {
          return "";
        },
      },
    },
    data() {
      return {
        
      };
    },
    mounted() { 
      this.$forceUpdate(); 
    },
    methods: {
     
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "../style/index.scss";
  
  .tips {
    font-size: 12px;
    color: #606266;
    margin-left: 20px;
  }
  
  .radio-list {
    width: calc(100% - 180px);
    margin-left: 20px;
  
    .list-a {
      width: 100%;
      line-height: 30px;
    }
  
    .tips {
      font-size: 12px;
      color: #606266;
    }
  }
  .goods-title{
    font-size: 14px;
    color: #303133;
  }
  </style>
  